// extracted by mini-css-extract-plugin
export default {"wrapper":"v3-z","play":"w3-z"};